<template>
  <div
    class="tw:flex tw:justify-between tw:items-center tw:hover:bg-default-000 tw:cursor-pointer tw:transition-all tw:duration-200 tw:ease-in-out"
    :data-item-id="trackerProductId"
    @click="handleViewProductDetails"
  >
    <div class="tw:flex tw:flex-col tw:p-3">
      <p class="tw:body-2 tw:text-black tw:line-clamp-1 tw:break-all" :title="title">{{ title }}</p>
      <p class="tw:caption tw:text-default-700">
        {{ formatNumberV2(price, { currency: currency, style: "currency" }) }}
      </p>
    </div>

    <EdroneButton v-if="productId" class="tw:mr-3" type="outline" size="small" @click="handleViewProductDetails">
      {{ trans._menu.searchBar.viewProductDetails }}
    </EdroneButton>
  </div>
</template>

<script setup lang="ts">
import EdroneButton from "edrone-components/EdroneButton.vue";
import { sendCustomEventToGA } from "vue-app/plugins/edroneGtag";
import { formatNumberV2 } from "vue-app/utils/functions";

interface Props {
  trackerProductId: number;
  productId: string | null;
  title: string;
  price: number;
}

interface Emits {
  viewProductDetails: [appIdProductId: string, trackerProductId: number];
}

const props = defineProps<Props>();
const emit = defineEmits<Emits>();

const currency = window.EDRONE_CONTEXT.user.currency;

const handleViewProductDetails = () => {
  const appIdProductId = window.EDRONE_CONTEXT.appId + "_" + props.productId;

  emit("viewProductDetails", appIdProductId, props.trackerProductId);
  sendCustomEventToGA("search_bar_view_product_details_click");
};
</script>
